export const USERS_COLLECTION = 'users';
export const MEDICATIONS_COLLECTION = 'medications';
export const PRESCRIPTIONS_COLLECTION = 'prescriptions';
export const PRESCRIPTION_NUMBERS_COLLECTION = 'numbers';
export const PRACTICES_COLLECTION = 'practices';
